<template>
  <div class="animated fadeIn">
    <div class="block-screen" v-if="loading"><i class="fa fa-refresh fa-spin"></i></div>
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <i class="fa fa-edit"></i> Participante:
          </div>
          <b-row class="form-group">
            <b-col md="3">
              <b-form-fieldset label="Código de confirmação">
                <b-input-group>
                  <b-form-input type="text" v-model="order.code">
                  </b-form-input>
                </b-input-group>
              </b-form-fieldset>
            </b-col>
            <b-col md="3">
              <b-form-fieldset label="Status">
                <b-form-select
                  :plain="true"
                  :options="[{value: 0, text: 'Pendente'}, {value: 1, text: 'Concluído'}]"
                  value="Status"
                  v-model="order.status">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col md="3">
              <b-button variant="default" @click="$parent.editOrder = false">
                <i class="fa fa-arrow-left"></i>&nbsp; Voltar
              </b-button>
              <b-button variant="primary" @click="update">
                <i class="fa fa-check"></i>&nbsp; Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'forms',
  props: {
    orderId: false
  },
  data () {
    return {
      order: {code: '', status: ''},
      loading: false
    }
  },
  watch: {
    orderId: function (val) {
      this.mount()
    }
  },
  mounted () {
    this.mount()
  },
  methods: {
    mount () {
      this.loading = true
      this.$http.get(`orders/${this.orderId}`)
        .then(response => {
          this.loading = false
          this.order = response.data.order
        })
        .catch(res => {
          this.loading = false
        })
    },
    update () {
      this.loading = true
      this.$http.put(`orders/${this.orderId}`, {status: this.order.status, code: this.order.code})
        .then(response => {
          this.loading = false
          this.$parent.editOrder = false
          this.$parent.showAlert()
        })
        .catch(res => {
          this.loading = false
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/orders/Edit.vue